var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1069,
    height: 436,
    viewBox: "0 0 1069 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.637 225.297V421.179L273.146 210.637V15.9368L795.637 225.297Z",
    fill: "url(#paint0_linear_44_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 123.923V319.805L273.143 210.637V15.9368L0 123.923Z",
    fill: "url(#paint1_linear_44_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.629 225.299V421.181L1068.74 312.014V117.313L795.629 225.299Z",
    fill: "url(#paint2_linear_44_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.143 258.515L53.1475 347.242L273.143 436L493.139 347.242L273.143 258.515Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.635 0L575.639 88.7266L795.635 177.485L1015.63 88.7266L795.635 0Z",
    fill: "white",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_74",
    x1: 863.38,
    y1: 451.33,
    x2: -197.188,
    y2: -300.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0510008,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446545,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_74",
    x1: 33061.2,
    y1: 9311.26,
    x2: -21136.3,
    y2: 22984.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_74",
    x1: 1208.06,
    y1: 224.277,
    x2: 703.772,
    y2: 306.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white",
    stopOpacity: 0.48
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logoBackground.58d357e2ab459b6808580697f71c0530.svg";
export { ForwardRef as ReactComponent };